import React from 'react';
import useMediaContext from "app/app/mediaSelector/hooks/use-media-context";
import MediaFilter from "app/app/mediaSelector/atoms/MediaFilter";
import useMediaFilter from "app/app/mediaSelector/hooks/use-media-filter";
import useMediaTranslation from "app/app/mediaSelector/hooks/use-translation";

function MediaHeader() {
    const trans = useMediaTranslation();
    const media = useMediaContext();
    const {
        filteredItems,
        availableCountryTerms,
        availableAreaTerms,
        availableTagTerms,
        handleCountryChange,
        handleAreaChange,
        handleTagChange,
        selectedCountry,
        selectedArea,
        selectedTag
    } = useMediaFilter();

    let showFilteredItemsCount = selectedCountry || selectedArea || selectedTag ? true : false;

    return (
        <div className={'media-header page_container'}>
            <h2 className={'media-select-title'}>
                <span className={'count'}>
                    {media.length}
                    &nbsp;
                    {media.length === 1 ? trans.general.file : trans.general.files}
                </span>

                {showFilteredItemsCount &&
                <span className={'filtered-count'}>
                    ( {trans.general.showing} {filteredItems.length} )
                </span>
                }

                {showFilteredItemsCount}
                &nbsp;
                {trans.general.download_desc}
            </h2>
            <div className={'media-filters'}>
                <MediaFilter
                    name={'tag'}
                    defaultOptionName={trans.filter.all_tags}
                    options={availableTagTerms}
                    onChange={handleTagChange}
                    selected={selectedTag}
                />
                <MediaFilter
                    name={'country'}
                    defaultOptionName={trans.filter.all_countries}
                    options={availableCountryTerms}
                    onChange={handleCountryChange}
                    selected={selectedCountry}
                />
                <MediaFilter
                    name={'area'}
                    defaultOptionName={trans.filter.all_areas}
                    options={availableAreaTerms}
                    onChange={handleAreaChange}
                    selected={selectedArea}
                />
            </div>
        </div>
    );
}

export default MediaHeader;
